(function ($, Drupal) {

  'use strict';
  $(document).ready(function () {
    let patientResourcesSlides = document.querySelectorAll('#slick-views-latest-patients-resources-carousel-latest-patient-resources-block-2-slider>div>div>div>div');
    let patientNewsSlides = document.querySelectorAll('#slick-views-latest-patients-news-carousel-latest-news-block-1-slider>div>div>div>div');
    let scientificNetworkSlides = document.querySelectorAll('#meet-the-scientific-network-slider>div>div>div>div');

    function slideHeight(slides) {
      /*This Function accept array of slides and make their height equal to the highest slide*/
      if (slides.length != 0) {
        let elemHeightArr = [];

        slides.forEach(elem => elemHeightArr.push(elem.offsetHeight));

        let maxHeight = elemHeightArr.reduce((a, b) => Math.max(a, b));

        slides.forEach(elem => elem.style.height = maxHeight + 'px');
      }
    }

    /* In order this script works in Internet Explorer*/
    if (typeof NodeList.prototype.forEach !== 'function') {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    slideHeight(patientResourcesSlides);
    slideHeight(patientNewsSlides);
    slideHeight(scientificNetworkSlides);
  });


})(jQuery, Drupal);
